export default __webpack_public_path__ + "static/media/class2.3908cdc6.png";